const language: Record<string, string> = {
    e0001: "Forbidden",
    e0002: "You don't have permission to access this channel.",
    e0003: "Page not found",
    e0004: "The requested page was not found.",
    e0005: "Service Error",
    e0006: "Sorry for the inconvenience in using the service.\n" +
        "A system error occurred and the page could not be displayed.",
    e0007: "An error occurred while retrieving data.",
    e0008: "",
    e0009: "The page cannot be displayed as an internal server error has occured.",
    e0010: "We apologize for the inconvenience. \nPlease try again later.",
    e0011: "Return to Home",

    b0001: "No",
    b0002: "Yes",
    b0003: "Confirm",
    b0004: "Cancel",

    i0000: "Service",
    i0001: "Subscriptions",
    i0002: "Resources",
    i0003: "User Guide",
    i0004: "Developers",
    i0005: "Language",
    i0006: "Korean",
    i0007: "English",
    i0008: "Sign up",
    i0009: "Login",
    i0010: "Account settings",
    i0011: "Channel list",
    i0012: "Log out",
    i0013: "Install SiteBunny\non your homepage",
    i0014: "Make it simple for your customers to discover everything about your company",
    i0015: "Get started for free",
    i0016: "Easily upload your homepage along with various data sources",
    i0017: "Upload files, including your homepage, or connect Notion, Google Drive, and more.\n" +
        "Our LLM and 42maru's RAG and Prompt Engineering technologies then deliver accurate answers to your customers based on these data sources.",
    i0018: "*Support coverage varies depending on your plan.",
    i0019: "Once you register your homepage URL, we’ll import all your webpage content and files",
    i0020: "PDF, Word, PPT, txt files are supported.",
    i0021: "You can also connect multiple Notion workspaces and Google Drive.",
    i0022: "Offer AI-generated suggested questions to your customers",
    i0023: "Make your chatbot user-friendly and let customers ask the questions that matter to them.\n" +
        "Effortlessly manage chatbots with AI that predicts customer questions.",
    i0024: "Click the ‘Suggested questions’ button below the chatbot speech bubble",
    i0025: "Immediately start the conversation with chatbot by clicking suggested question",
    i0026: "Set your own suggested questions for specific chatbot messages",
    i0027: "Do you want provide a fixed response?",
    i0028: "Set the chatbot to provide consistent answers for specific questions.\n" +
        "Respond with the chatbot administrator's preset answer, not LLM-generated responses.",
    i0029: "Monitor your bot's conversations and easily update questions and answers.",
    i0030: "Register similar messages to help your chatbot identify specific questions.",
    i0031: "Create ‘source URLs’ and ‘suggested questions’ to show with the bot's answers.",
    i0032: "Incorporate your company's identity.",
    i0033: "Apply your company's logo and brand colors to your chatbot.\n" +
        "Customize the chatbot color and button design freely.\n" +
        "Add your corporate logo to the button.",
    i0034: "Select between 'solid color' and 'gradient' to apply colors.",
    i0035: "The selected color will be reflected in the overall style of the chatbot",
    i0036: "Add a text phrase alongside the button image.",
    i0037: "Subscription",
    i0038: "Please choose the plan that best suits you.",
    i0039: "Monthly",
    i0040: "Annually",
    // i0041: "{price}",
    // i0041_1: "per month",
    // i0042: "{price}",
    // i0042_1: "per year",
    i0041: "Price TBD",
    i0041_1: " ",
    i0042: "Price TBD",
    i0042_1: " ",
    i0043: "Subscribe with {name} plan",
    i0044: "Terms of Service",
    i0045: "Privacy Policy",
    i0046: "Company: 42maru",
    i0047: "CEO: Donghwan Kim",
    i0048: "Address: 1-7F, Movie Building, 310, Sinbanpo-ro, Seocho-gu, Seoul, Korea (06533)",
    i0049: "Customer Service: 02-6952-9201",
    i0050: "Email: www.42maru.ai",
    i0051: "2024 SiteBunny. All rights reserved",
    i0052: "User guide not yet available.",
    i0053: "Developer docs not yet available.",
    i0054: "Terms of Service not yet available.",
    i0055: "Privacy Policy not yet available.",
    i0056: "Sign up on SiteBunny by creating a new channel.\nIf you were invited, please click 'Sign up'",
    i0057: "You already have channels.\nDo you create a new channel?",
    i0058: "Yes",
    i0059: "To\u00a0Channel\u00a0List",
    i0060: "Create\u00a0New\u00a0Channel",
    i0061: "Sign up",
    i0062: "Error occurred. Please try again later.",
    i0063: "Account Settings",
    i0064: "Email",
    i0065: "Name",
    i0066: "Save",
    i0067: "Change password",
    i0067_1: "Delete account",
    i0067_2: "Are you sure you want to delete your account?\nAll data created with this account will be removed.",
    i0067_3: "Your account has been deleted.",
    i0067_4: "An error occurred while deleting your account.",
    i0068: "Please enter your name.",
    i0069: "Successfully changed the name.",
    i0070: "The name cannot be longer than 15 characters.",
    i0071: "An error occurred while changing the name.",
    i0072: "Do you want to create a new channel?\nYou will be directed to onboarding.",
    i0073: "Enter a name.",
    i0074: "Delete account",
    i0075: "Change password",
    i0076: "Wrong password.",
    i0077: "You cannot use the same password as before.",
    i0078: "Your password has been successfully changed. Please sign in again.",
    i0079: "An error occurred while changing the password.",
    i0080: "Please enter the new password.\nAfter changing your password,\nplease sign in again.",
    i0081: "Old password",
    i0082: "New password",
    i0083: "Confirm new password",
    i0084: "Password must be 8-15 characters and contain at least one english letter, one number, and one special character.",
    i0085: "Are you sure you want to sign out?",
    i0086: "Sign out",
}

export default language;
